var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nullPage"},[_c('img',{class:[{ smallImg: _vm.isSmall }],attrs:{"src":require("../../../assets/nullPage.png"),"alt":""}}),_vm._v(" "),_vm._t("tipsText")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// /Users/wangmengyuan/Code/xbz-students-web/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-98b52754","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!/Users/wangmengyuan/Code/xbz-students-web/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/practise/components/nullPage.vue
// module id = null
// module chunks = 